<div class="product-overview-title"></div>
<div class="mainHeader sticky" *ngIf='npPerspective ; else orgPerspective'>
  <div class="mainHeaderTab" [ngClass]="{'active': showProductOverview}" (click)='openProductOverview()'>{{data.products}}</div>
  <div class="mainHeaderTab" [ngClass]="{'active': showCollateralObject}" (click)="openCollateralObjects()">{{data.collateralObjects}}</div>
</div>
<ng-template #orgPerspective>
  <div class="mainHeader sticky" >
    <div class="mainHeaderTab" [ngClass]="{'active': showProductOverview}" (click)='openProductOverview()'>{{data.products}}</div>
    <div class="mainHeaderTab" [ngClass]="{'active': showCustomerContribution}" (click)="openCustomerContribution()">{{data.customerContribution}}</div>
    <div class="mainHeaderTab" (click)="openFinancingView()">{{data.financingView}}</div>
  </div>
</ng-template>

<app-po-treeview [hidden]="!showProductOverview" ></app-po-treeview>
<app-collateral-objects [hidden]="!showCollateralObject"></app-collateral-objects>
<app-customer-contribution [hidden]="!showCustomerContribution"></app-customer-contribution>
